import { render } from "./ContactsSection.vue?vue&type=template&id=2edf862f"
import script from "./ContactsSection.vue?vue&type=script&lang=js"
export * from "./ContactsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__